import CustomerPage from "@/views/customer/CustomerPage.vue";
import CourseArea from "@/views/customer/children/course/Course.vue";
import Dashboard from "@/views/customer/children/dashboard/Dashboard.vue";
import CustomerProfile from "@/views/customer/children/profile/Profile.vue";
import CustomerClasses from "@/views/customer/children/classes/Classes.vue";
import CustomerCalendar from "@/views/customer/children/calendar/Calendar.vue";
import CourseContentPage from "@/views/customer/children/course/CourseContent.vue";
import NotificationsArea from "@/views/customer/children/notifications/NotificationsArea.vue";

const prefix = "/connect/aluno";

export const customer_routes = [
  {
    path: prefix,
    name: "Bem-vindo",
    component: CustomerPage,
    meta: { authRequired: true, preventAuth: true },
    children: [
      {
        path: `${prefix}/cockpit`,
        name: "Dashboard",
        component: Dashboard,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/perfil`,
        name: "Perfil",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerProfile,
      },
      {
        path: `${prefix}/curso`,
        name: "Curso",
        meta: { authRequired: true, preventAuth: true },
        component: CourseArea,
      },
      {
        path: `${prefix}/curso/:id`,
        name: "Aulas",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContentPage,
      },
      {
        path: `${prefix}/turmas`,
        name: "Turmas",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerClasses,
      },
      {
        path: `${prefix}/notificacoes`,
        name: "Notificacoes",
        meta: { authRequired: true, preventAuth: true },
        component: NotificationsArea,
      },
      {
        path: `${prefix}/agenda`,
        name: "Agenda",
        meta: { authRequired: true, preventAuth: true },
        component: CustomerCalendar,
      },
    ],
  },
];
